export default "__VITE_ASSET__DgNOtUsN__"